module.exports = __webpack_public_path__ + "img/hand-ok.6a55e584.png";